import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/member-benefits',
  exact: true,
  name: 'navigation.menu.perks',
  private: true,
  type: containerTypes.SUBCONTENT,
  requiresMemberPortalAccess: true,
};

export default RouteConfig;
